export default {
  id: 'reports',
  title: 'Reports',
  category: 'Admin',
  summary: 'Run canned operational and financial reports such as labor distribution, leave, and billable time.',
  overview: 'The Reports hub lists available canned reports. Each report has filters and output appropriate to its purpose — from timesheet compliance to labor revenue and Schedule K summaries.',
  howItWorks: [
    'Select a report card to open its dedicated page.',
    'Set filters (dates, employees, projects, etc.) then generate results.',
    'Some reports include drill-down modals for cost or project breakdowns.',
    'Export options may be available depending on the report.'
  ],
  actions: [
    {
      name: 'Open a report',
      description: 'Navigates to that canned report’s parameter and results page.'
    },
    {
      name: 'Apply filters and run',
      description: 'Queries the selected data set and displays results in the report grid or summary.'
    },
    {
      name: 'Drill into breakdowns',
      description: 'On supported reports (for example labor distribution), opens detailed cost breakdown modals.'
    }
  ],
  tips: [
    'Report availability can depend on permissions and company configuration.',
    'Use consistent date ranges when comparing period-over-period results.'
  ],
  related: ['invoices', 'timesheet', 'projects']
};



// WEBPACK FOOTER //
// ./client/help/content/reports.js